import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { reloadUser, executeUserAction } from '../../actions/user'
import { getLink } from "../../dataProvider/links.js"

import loader from '../../img/v1/payment/loader.gif'

import "../../scss/v2/payment.scss"

function Secure(props) {

    const { i18n } = useTranslation();
    const [locked, setLocked] = useState(false);
    const form = useRef(null);
    let navigate = useNavigate();
    let location = useLocation();

    function getErrorPath() {
        return `${getLink("payment1", i18n.language)}?error=server`
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const status = params.get('status');
        if (!status && !props.nextAction) return navigate(getErrorPath());

        if (form.current) form.current.submit();

        if(props.nextAction && props.nextAction.type === 'redirect') return window.location.href = props.nextAction.url;

        window.addEventListener('message', handleMessage);

        if (status) window.postMessage(status === 'success' ? 'secure_success' : 'secure_error', '*');

        return function cleanup() {
            window.removeEventListener('message', handleMessage);
        }
    })

    function handleMessage(e) {
        if (locked) return;

        let message = {};
        try {
            message = JSON.parse(e.data);
        } catch (error) {
            if (e.data === 'secure_success') message = { type: 'success' };
            if (e.data === 'secure_error') message = { type: 'error' };
        }

        if (message.type) setLocked(true);

        if (message.type === 'redirect') return window.location.href = message.url;

        if (message.type === 'success') props.dispatch(executeUserAction())
            .then(() => props.dispatch(reloadUser()))
            .then(user => {
                if (user.status !== 'ok') return navigate(getErrorPath());
                navigate(getLink('paymentConfirmation', i18n.language));
            })
            .catch(err => {
                console.error(err);
                navigate(getErrorPath());
            })

        else if (message.type === 'error') navigate(getErrorPath());
    }

    function renderSecure() {
        if (props.nextAction.type === 'form') {
            const paramElements = props.nextAction.parameters.reduce((paramElements, parameter, index) => {
                paramElements.push((<input type="hidden" name={parameter.name} value={parameter.value} key={index} />))
                return paramElements
            }, [])

            return (
                <form method="post" action={props.nextAction.url} ref={form} >
                    {paramElements}
                    <div className="d-flex justify-content-center mb-4">
                        <div className="spinner-border" role="status" />
                    </div>
                </form>
            );
        }

        return (
            <iframe
                sandbox="allow-top-navigation allow-scripts allow-forms"
                src={props.nextAction}
                style={{ backgroundImage: `url(${loader})` }}
                title="Secure payment"
            />
        )
    }

    if (!props.nextAction) return (
        <div className="d-flex justify-content-center mb-4">
            <div className="spinner-border" role="status" />
        </div>
    );

    return (
        <div className="payment-secure container">
            <div className="row">
                <div className="col-12 col-lg-8 offset-lg-2">{renderSecure()}</div>
            </div>
        </div>
    )

}

const mapStateToProps = state => ({ nextAction: state.user.paymentNextAction });

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(Secure);